import 'focus-visible';
import { appWithTranslation } from 'next-i18next';
import fonts from '../themes/fonts';
import '../styles/index.scss';

function MyApp({ Component, pageProps }) {
    return <Component {...pageProps} />;
}

export default appWithTranslation(MyApp);
